import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoTypeaheadClienteCentralCompraComponent } from './novo-typeahead-cliente-central-compra.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoTypeaheadClienteCentralCompraComponent],
  exports: [NovoTypeaheadClienteCentralCompraComponent],
})
export class NovoTypeaheadClienteCentralCompraModule {}
